import { uri } from '../../api-endpoint';
import { deleteTemplateFn } from '../common';

export const deleteModelImageAnnotation = (token: string) => (
  modelId: number,
  imageId: number,
  annotationUuid: string
) =>
  deleteTemplateFn(
    token,
    uri.modelImageAnnotationById(modelId, imageId, annotationUuid)
  );
